import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted, onUnmounted, computed } from "vue";
  import router from "@/router";
  import store from "@/store";
  import Cleave from "vue-cleave-component";
  import SliderLimited from "@/components/ui/SliderLimited.vue";
  import useVuelidate from "@vuelidate/core";
  import {
    required,
    email,
    minLength,
    numeric,
    helpers,
  } from "@vuelidate/validators";
  import { validPhoneNumber } from "@/helpers/validation";
  import HeaderCustomer from "@/components/HeaderCustomer.vue";
  import LotCardWaitlist from "@/components/eoi/LotCardWaitlist.vue";
  import { LotRangeInterface } from "@/types/LotRangeInterface";
  import { scrollTo } from "@/helpers/smoothScrollToElement";
  import { phoneNumberOption } from "@/helpers/cleavePlugin";
  import { defaultRange } from "@/static/waitlist";
  import {
    changePrimaryColor,
    resetPrimaryColor,
  } from "@/helpers/customer/changePrimaryColor";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'EOIWaitlist',
  setup(__props, { expose: __expose }) {
  __expose();

  const estateId = ref(router.currentRoute.value.params.estateId);
  const estate = ref({});
  const range: LotRangeInterface = defaultRange;
  const lotSize = ref([range.size.min, range.size.max]);
  const budget = ref([range.budget.min, range.budget.max]);
  const frontage = ref([range.frontage.min, range.frontage.max]);
  const showPage = ref(false);

  const waitlistForm = reactive({
    estateId: estateId.value,
    buyerDetails: {
      firstName: "",
      lastName: "",
      email: "",
      phone: "",
      postcode: "",
    },

    budget: {
      from: 0,
      to: 0,
    },
    lotSize: {
      from: 0,
      to: 0,
    },
    frontage: {
      from: 0,
      to: 0,
    },
  });

  const rules = computed(() => {
    return {
      buyerDetails: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        phone: {
          validPhoneNumber: waitlistForm.buyerDetails.phone
            ? helpers.withMessage(
                "Value must be valid phone number",
                validPhoneNumber
              )
            : true,
        },
        postcode: { numeric, minLength: minLength(4) },
      },
    };
  });

  const v$ = useVuelidate(rules, waitlistForm);

  onMounted(() => {
    store.dispatch("estate/getEstate", estateId.value).then((res) => {
      estate.value = res.data;
      changePrimaryColor(estate.value.iconColor);
    });
    showPage.value = true;
  });

  onUnmounted(() => {
    resetPrimaryColor();
  });

  const submit = () => {
    v$.value.$touch();
    setTimeout(() => {
      const errors = document.getElementsByClassName("error");

      errors[0] && scrollTo(errors[0], 100);
    });

    if (v$.value.$invalid) {
      return;
    }

    waitlistForm.budget.from = budget.value[0];
    waitlistForm.budget.to = budget.value[1];
    waitlistForm.lotSize.from = lotSize.value[0];
    waitlistForm.lotSize.to = lotSize.value[1];
    waitlistForm.frontage.from = frontage.value[0];
    waitlistForm.frontage.to = frontage.value[1];

    const waitlistItem = {
      personData: {
        estateId: estateId.value,
        email: waitlistForm.buyerDetails.email,
        firstName: waitlistForm.buyerDetails.firstName,
        lastName: waitlistForm.buyerDetails.lastName,
        phone: waitlistForm.buyerDetails.phone,
        postcode: waitlistForm.buyerDetails.postcode,
      },
      criteria: {
        budget: waitlistForm.budget,
        lotSize: waitlistForm.lotSize,
        frontage: waitlistForm.frontage,
      },
    };

    store
      .dispatch("subscription/addSubscriptionForLead", waitlistItem)
      .then(() => {
        router.push(`/v2/estate/${estateId.value}/waitlist-confirmation`);
      });
  };

const __returned__ = { estateId, estate, range, lotSize, budget, frontage, showPage, waitlistForm, rules, v$, submit, ref, reactive, onMounted, onUnmounted, computed, get router() { return router }, get store() { return store }, get Cleave() { return Cleave }, SliderLimited, get useVuelidate() { return useVuelidate }, get required() { return required }, get email() { return email }, get minLength() { return minLength }, get numeric() { return numeric }, get helpers() { return helpers }, get validPhoneNumber() { return validPhoneNumber }, HeaderCustomer, LotCardWaitlist, get LotRangeInterface() { return LotRangeInterface }, get scrollTo() { return scrollTo }, get phoneNumberOption() { return phoneNumberOption }, get defaultRange() { return defaultRange }, get changePrimaryColor() { return changePrimaryColor }, get resetPrimaryColor() { return resetPrimaryColor } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})